<!--样式引入-->
<style scoped lang="scss" src="./index.scss"></style>

<!--模版引入-->
<template lang="pug" src="./index.pug"></template>

<script>
import html2canvas from "html2canvas";
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
    };
  },
  computed: {
    ...mapState(['userInfo','authToken','user_title'])
  },
  watch: {
    
  },
  created: function() {
  },
  mounted: function() {
  },
  methods: {
    //生成下载图片
    createPicture() {
      this.$toast.loading({
        message: "处理中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });
      html2canvas(this.$refs.downBody)
          .then(canvas => {
            this.$toast.clear();
            var imgData = canvas.toDataURL("image/png");
            this.$glf.downLoad('歆医荟', imgData);
          })
          .catch(error => {
            console.log(error);
          });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/mine/share/index.vue